import React from "react";

const ResponsiveImage = ({
    image,
    imageAlt,
    use1080 = false,
    className = "",
    imgClassName = "",
    children
}) => {
    return (
        <div
            className={`
        relative
        w-full
        overflow-hidden
        bg-gray-900
        ${use1080 ? "aspect-[1920/1080]" : "aspect-[1920/855]"}
        ${className}
      `}
        >
            <img
                src={image}
                alt={imageAlt}
                className={`
          absolute
          inset-0
          w-full
          h-full
          object-cover
          object-center
          ${imgClassName}
        `}
            />
            {children}
        </div>
    );
};

export default ResponsiveImage;
